export const defaultLanguage = 'en';

export const supportedLanguages = [
    { code: 'en', name: 'English' },
    { code: 'ua', name: 'UA' },
    { code: 'ru', name: 'RU' },
];
